module.exports = {
  azul: "#1976d2",
  amarillo: "#daf63e",
  negro: "#1D1D1D",
  blanco: "#FFFFFF",
  verde: "#009B4D",
  amarillo_mandarina: "#FFCC00",
  marfil: "#FAF5E9",
  verde_amarella: "#BAFF39",
  gris_tenue: "#6E6E6E",
  azul_claro: "#E9F1FA",
  rojo_intenso: "#8E0D3C",
  grosella_negra: "#1D1842",
  naranja: "#EF3B33",
  rosa: "#FDA1A2",
};
